import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const MagicWand = props => (
  <SvgIcon viewBox="0 0 15.245 15.245" {...props}>
    <g id="Magic_Wand" data-name="Magic Wand" transform="translate(0 0)">
      <path id="magic-wand-icon" data-name="Path 7891" d="M4.72,2.613,6.534,3.629,5.518,1.815,6.534,0,4.72,1.016,2.905,0,3.921,1.815,2.905,3.629Zm8.71,7.113L11.615,8.71l1.016,1.815-1.016,1.815,1.815-1.016,1.815,1.016-1.016-1.815L15.245,8.71ZM15.245,0,13.43,1.016,11.615,0l1.016,1.815L11.615,3.629,13.43,2.613l1.815,1.016L14.228,1.815ZM9.706,3.84a.723.723,0,0,0-1.023,0L.212,12.31a.723.723,0,0,0,0,1.023l1.7,1.7a.723.723,0,0,0,1.023,0L11.4,6.569a.723.723,0,0,0,0-1.023L9.706,3.84ZM8.959,7.825,7.42,6.286,9.191,4.515,10.73,6.054,8.959,7.825Z" fill="#195a7c" />
    </g>
  </SvgIcon>
);

export default MagicWand;
